// action types
export const STEP = "Step";
export const MODAL_NEW = "modalNew";
export const MODAL_EDIT = "modalEdit";

// mutation types
export const SET_STEP = "setStep";
export const SET_NEW = "setNew";
export const SET_EDIT = "setEdit";

export default{
    state: {
        step: 0,
        modaledit: false,
        modalnew: false
    },
    getters: {
        currentstep(state){
            return state.step;
        },
        modalNew(state){
            return state.modalnew;
        },
        modalEdit(state){
            return state.modaledit;
        }
    },
    actions: {
        [STEP](state, payload) {
            state.commit(SET_STEP, payload);
        },
        [MODAL_NEW](context, data){
            context.commit(SET_NEW, data);
        },
        [MODAL_EDIT](context, data){
            context.commit(SET_EDIT, data);
        },
    },
    mutations: {
        [SET_STEP](state, payload) {
            state.step = payload;
        },
        [SET_NEW](state, data){
            state.modalnew = data;
        },
        [SET_EDIT](state, data){
            state.modaledit = data;
        }
    }
}